<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-0">
    <div *ngIf="insertionMessage != null" class="progress-message">
        <span *ngIf="isInserting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ insertionMessage }}
    </div>
    <div *ngIf="formatError" class="alert alert-danger">
        <p>The format of the imported data is incorrect. Please ensure the CSV matches the required format.</p>
        <p><strong>Expected columns:</strong> description, employee, payroll, department, validFrom, validTo, weekday, isRestDay, time1–time6, addMissingTime, computeRestDay, computeHoliday, adjustOT, computeNightDiff</p>
    </div>
    <div class="table-responsive" *ngIf="displayTable">
        <table *ngIf="!formatError" mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <input type="checkbox" (change)="toggleSelectAll($event.target.checked)"
                        [checked]="selectedRows.length === importedData.length && importedData.length > 0">
                </th>
                <td mat-cell *matCellDef="let row">
                    <input type="checkbox" (change)="onCheckboxChange(row, $event.target.checked)"
                        [checked]="isSelected(row)">
                </td>
            </ng-container>

            <ng-container matColumnDef="rowType">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Row Type</th>
                <td mat-cell *matCellDef="let row">
                    <span [class]="row._rowType === 'header' || row._rowType === 'header+line' ? 'badge badge-primary' : 'badge badge-secondary'">
                        {{ row._rowType }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Description</th>
                <td mat-cell *matCellDef="let row">{{ row.description }}</td>
            </ng-container>

            <ng-container matColumnDef="employee">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Employee</th>
                <td mat-cell *matCellDef="let row">{{ row.employee }}</td>
            </ng-container>

            <ng-container matColumnDef="payroll">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Payroll</th>
                <td mat-cell *matCellDef="let row">{{ row.payroll }}</td>
            </ng-container>

            <ng-container matColumnDef="department">
                <th mat-header-cell class="text-primary" *matHeaderCellDef mat-sort-header>Department</th>
                <td mat-cell *matCellDef="let row">{{ row.department }}</td>
            </ng-container>

            <ng-container matColumnDef="validFrom">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Valid From</th>
                <td mat-cell *matCellDef="let row">{{ row.validFrom }}</td>
            </ng-container>

            <ng-container matColumnDef="validTo">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Valid To</th>
                <td mat-cell *matCellDef="let row">{{ row.validTo }}</td>
            </ng-container>

            <ng-container matColumnDef="weekday">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Weekday</th>
                <td mat-cell *matCellDef="let row">{{ row.weekday }}</td>
            </ng-container>

            <ng-container matColumnDef="isRestDay">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Rest Day</th>
                <td mat-cell *matCellDef="let row">{{ row.isRestDay }}</td>
            </ng-container>

            <ng-container matColumnDef="time1">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Time In</th>
                <td mat-cell *matCellDef="let row">{{ row.time1 }}</td>
            </ng-container>

            <ng-container matColumnDef="time2">
                <th mat-header-cell class="text-primary" *matHeaderCellDef>Time Out</th>
                <td mat-cell *matCellDef="let row">{{ row.time2 }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator *ngIf="!formatError" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
    </div>
</div>

<div class="modal-footer large-modal" *ngIf="!isImported">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
    <button *ngIf="!isLoading; else loadingTemplate" [disabled]="formatError" type="button" class="btn btn-primary"
        (click)="saveSelectedScales()">
        Save
    </button>
    <ng-template #loadingTemplate>
        <button type="button" class="btn btn-primary" disabled>
            Save <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
    </ng-template>
</div>

<div class="modal-footer large-modal" *ngIf="isImported">
    <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
</div>
